module.exports = __webpack_public_path__ + "img/listguanggao.cfcc10ef.png";